import CertificateList from "./components/List"
import CertificateForm from "./components/Form"
import CertificateView from "./components/View"

let module = "certificates"

export default [
  { path: "certificates", component: CertificateList, meta: { module: module, permissions: ["certificate-access"] } },
  {
    path: "certificates/create",
    component: CertificateForm,
    props: true,
    meta: { module: module, permissions: ["certificate-create"] }
  },
  {
    path: "certificates/edit/:id",
    component: CertificateForm,
    props: true,
    meta: { module: module, permissions: ["certificate-edit"] }
  },
  {
    path: "certificates/view/:id",
    component: CertificateView,
    props: true,
    meta: { module: module, permissions: ["certificate-access"] }
  }
]
